import request from '@/utils/request'

// 查询是否绑定手机号
export function check_bind() {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/phone/check_bind',
    method: 'post'
  })
}
// 绑定手机号
export function bind(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/phone/bind',
    method: 'post',
    data
  })
}
